// DataReconETRMFileUploadStyles.tsx
import styled from 'styled-components';

export const Container = styled.div`
  border-top: 1px solid var(--Border-Subtle, rgba(28, 28, 28, 0.04));
  padding-top: 16px;
`;
